/* eslint-disable @typescript-eslint/naming-convention */
export enum scalingTypesEnum {
    ascending,
    descending
}
